module.exports = __webpack_public_path__ + "static/media/smart-box-logo.89d717ee.png";